/** Lightweight email check without complex regex (Sonar-safe). */
export function isValidEmailAddress(email) {
  if (!email || typeof email !== "string") return false;
  const trimmed = email.trim();
  const at = trimmed.indexOf("@");
  if (at <= 0) return false;
  const domain = trimmed.slice(at + 1);
  const dot = domain.indexOf(".");
  return dot > 0 && dot < domain.length - 1;
}
